import React, { forwardRef, useMemo } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';

const getDisplayName = (appliedFilters) => {
  if (appliedFilters.length > 1) {
    return <FormattedMessage defaultMessage='(Multiple Services)' description='filterOptions.multipleServices' id='uajN4V' />;
  }

  return <FormattedMessage defaultMessage='Service' description='filterOptions.service' id='8CHawx' />;
};

export const Service = forwardRef((props, ref) => {
  const appliedFilters = useSelector((state) =>
    Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
      filterById: props.filterById,
    }),
  );

  const displayContent = useMemo(() => getDisplayName(appliedFilters), [appliedFilters]);
  return <ActionableFilterPill {...props} ref={ref} displayContent={displayContent} isSelected={!!appliedFilters.length} />;
});

Service.propTypes = {
  filterById: PropTypes.string,
};
